import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/components/common";

const FIELDS = [
  ["max_budget_change_pct", "Max budget change per campaign per day (±%)"],
  ["max_auto_changes_per_day", "Max auto-changes per day"],
  ["min_spend", "Minimum data: spend (S$)"],
  ["min_clicks", "…or minimum clicks"],
  ["waste_spend", "Pause keywords/ads with spend ≥ S$ and 0 conversions"],
  ["watchdog_pct", "Spend watchdog: act when pacing above % of daily cap"],
];

export default function GuardrailsPanel() {
  const [g, setG] = useState(null);
  useEffect(() => { api.get("/settings/autopilot").then((r) => setG(r.data.guardrails)); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/settings/autopilot", { guardrails: g }); setG(data.guardrails); toast.success("Guardrails saved"); } catch (err) { toast.error(errMsg(err)); }
  };
  if (!g) return null;
  return (
    <Panel title="Autopilot guardrails" icon={ShieldAlert} testid="guardrails-panel">
      <p className="mb-4 text-sm text-slate-400">Enforced on the server for every optimiser and autopilot change. The monthly budget cap (Business Profile ÷ 30.4) is never exceeded, and the last active ad in an ad group is never paused.</p>
      <form onSubmit={save} className="grid gap-3 md:grid-cols-2">
        {FIELDS.map(([k, label]) => (
          <label key={k} className="text-xs text-slate-400">{label}
            <input data-testid={`guardrail-${k}`} type="number" min="0" step="1" className="cc-input mt-1 font-mono" value={g[k]} onChange={(e) => setG({ ...g, [k]: e.target.value })} />
          </label>
        ))}
        <div className="md:col-span-2"><button data-testid="guardrails-save" className="cc-btn cc-btn-primary">Save guardrails</button></div>
      </form>
    </Panel>
  );
}
